import CancelIcon from '@mui/icons-material/Cancel';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { IconButton,Stack,Typography } from '@mui/material';
import React,{ useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import { trackEventMatomo } from '../../helpers/matomo';

export default function ModalInvalid({ openModal }: { openModal: Function }) {
  const { popUp, escape } = useContext(UserContext);

  return (
    <div className={`modal ${popUp ? "modal is-active" : "modal"}`}>
      <div className="modal-background" onKeyDown={() => {
        trackEventMatomo('dashboard', 'click', 'modal', 'fecha modal');
        escape();
      }} onClick={() => {
        trackEventMatomo('dashboard', 'click', 'modal', 'fecha modal');
        openModal();
      }} />
      <div className="modal-card" onSubmit={(e: React.FormEvent) => e.preventDefault()}>
        <header className="modal-card-head">
          <Stack direction='row' alignItems='flex-start' justifyContent='center' width='100%'>
            <Stack width={'95%'} justifyContent='flex-end' alignItems='center'>
              <ErrorOutlineIcon color='error' sx={{fontSize: 80}}  />
            </Stack>
            <Stack width={'5%'}>
              <IconButton color='error' onClick={() => {
                trackEventMatomo('dashboard', 'click', 'botão', 'fecha modal de dashboard indisponível');
                openModal();
              }}>
                <CancelIcon />
              </IconButton>
            </Stack>
          </Stack>
        </header>
        <div className="modal-card-body" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography color='textSecondary' variant='h5' textAlign='justify' >
            Você ainda não possui dashboards customizados contratados.
            Entre em contato com o time de serviços da Axyma e conheça como podemos criar análises exclusivas para o seu negócio.
          </Typography>
        </div>
      </div>
    </div>
  );
}
